import React, { useEffect, useMemo, useRef, useState } from "react";
import _ from "lodash";
import { Autocomplete } from "@material-ui/lab";
import { Link, useParams } from "react-router-dom";
import AddNewVessel from "../../../../../components/Dashboard/AddNewVessel";
import DeleteIcon from "@material-ui/icons/Delete";

import { checkValidation, toastError, toastSuccess } from "../../../../../utils";
import * as calculatorActions from "../../../Calculator/actions";
import * as dashboardActions from "../../../Dashboard/actions";
import { Button, Grid, Paper, Popper, Switch, TextField, Tooltip } from "@material-ui/core";
import {
    vesselCalculatorMainFields,
    vesselDetailsOption1,
    vesselDetailsOption2,
} from "../../../../../constants";
import { handleKeyDown } from "../../../../../common/common";
import CustomButton from "../../../../../components/Common/CustomButton";
import SplitHireModal from "../../../../../components/Calculator/SplitHireModal";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import { useDispatch } from "react-redux";
import * as commonActions from "../../../../Common/actions";
import { Document, Page, PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { GrDocumentPdf } from "react-icons/gr";
import DownloadPdf from "../downloadPdf";
import CustomConfirmModal from "../../../../../components/Common/CustomConfirmModal";

const useStyles = makeStyles((theme) => ({
    // borderless "excel cell" autocomplete: the <td> already draws the border
    portCell: {
        width: "100%",
        "& .MuiOutlinedInput-root": { height: 19, padding: "0 20px 0 0 !important", borderRadius: 0, background: "transparent" },
        "& .MuiOutlinedInput-notchedOutline": { border: "none !important" },
        "& .MuiOutlinedInput-root .MuiOutlinedInput-input": {
            padding: "0 4px !important", height: 19, fontSize: 11, border: "none", outline: "none", boxShadow: "none",
            // The input wrapper owns the focus ring; avoid a second ring inside it.
            "&:focus, &:focus:hover, &:focus-visible, &:focus-visible:hover": {
                outline: "none !important",
                boxShadow: "none !important",
                WebkitBoxShadow: "none !important",
            },
        },
        "& .MuiAutocomplete-endAdornment": { display: "none" },
    },
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
        background: "#fff"
    },
    instructions: {
        marginTop: 6,
        marginBottom: 4,
    },
}));

const WidePopper = (props) => <Popper {...props} placement="bottom-start" style={{ ...props.style, width: "auto", minWidth: 300, maxWidth: 420 }} />;

function getSteps() {
    return ['Vessel details', 'Bunker details', 'Hire and Split hire', "Extra expenses & Constants", "Confirmation"];
}


const initialRowData = {
    vesselName: "",
    vesselDwt: 0,
    vesselIMO: 0,
    vesselBalSpd1: 0,
    vesselBalConsmHS1: 0,
    vesselBalConsmLS1: 0,
    vesselBalConsmMGO1: 0,
    vesselBalSpd2: 0,
    vesselBalConsmHS2: 0,
    vesselBalConsmLS2: 0,
    vesselBalConsmMGO2: 0,
    vesselBalSpd3: 0,
    vesselBalConsmHS3: 0,
    vesselBalConsmLS3: 0,
    vesselBalConsmMGO3: 0,
    vesselBalSpd4: 0,
    vesselBalConsmHS4: 0,
    vesselBalConsmLS4: 0,
    vesselBalConsmMGO4: 0,
    vesselLdnSpd1: 0,
    vesselLdnConsmHS1: 0,
    vesselLdnConsmLS1: 0,
    vesselLdnConsmMGO1: 0,
    vesselLdnSpd2: 0,
    vesselLdnConsmHS2: 0,
    vesselLdnConsmLS2: 0,
    vesselLdnConsmMGO2: 0,
    vesselLdnSpd3: 0,
    vesselLdnConsmHS3: 0,
    vesselLdnConsmLS3: 0,
    vesselLdnConsmMGO3: 0,
    vesselLdnSpd4: 0,
    vesselLdnConsmHS4: 0,
    vesselLdnConsmLS4: 0,
    vesselLdnConsmMGO4: 0,
    vesselPIdleConsmHS: 0,
    vesselPIdleConsmLS: 0,
    vesselPIdleConsmMGO: 0,
    vesselPLdgConsmHS: 0,
    vesselPLdgConsmLS: 0,
    vesselPLdgConsmMGO: 0,
    vesselPDischConsmHS: 0,
    vesselPDischConsmLS: 0,
    vesselPDischConsmMGO: 0,
    vesselVExtraConsmHS: 0,
    vesselVExtraConsmLS: 0,
    vesselVExtraConsmMGO: 0,
    vesselBalComb1Selected: false,
    vesselBalComb2Selected: false,
    vesselBalComb3Selected: false,
    vesselBalComb4Selected: false,
    vesselLadComb1Selected: false,
    vesselLadComb2Selected: false,
    vesselLadComb3Selected: false,
    vesselLadComb4Selected: false,
    vesselExtraDetails: {}
};

const initialVessel = {
    bnkDelhs: 0,
    bnkDells: 0,
    bnkDelmgo: 0,
    bnkPriceDeliveryhs: 0,
    bnkPriceDeliveryls: 0,
    bnkPriceDeliverymgo: 0,
    bnkPriceRedeliveryhs: 0,
    bnkPriceRedeliveryls: 0,
    bnkPriceRedeliverymgo: 0,
    bnkPriceSettlemenths: 0,
    bnkPriceSettlementls: 0,
    bnkPriceSettlementmgo: 0,
    bnkQtyRedeliveryhs: 0,
    bnkQtyRedeliveryls: 0,
    bnkQtyRedeliverymgo: 0,
    bnkRedeliveryQtyTolerancehs: 0,
    bnkRedeliveryQtyTolerancels: 0,
    bnkRedeliveryQtyTolerancemgo: 0,
    bunkerPriceOverridden: false,
    dateOpen: Date.now()
}
export const toPdfVessel = (item) => ({ ...initialVessel, vesseldata: { ...initialRowData, ...item?.vesseldata }, ...item });

export const buildVesselPdfData = (vessel) => {
    const {

        vesselName = "",
        vesselDwt = 0,
        vesselIMO = 0,
        vesselDraftS = 0,
        vesselTPC,
        vesselGrainCap,
        vesselBuilt,
        vesselLOA,
        vesselBeam,
        vesselGRT,
        vesselNRT,
        vesselLightShip,
        vesselBaleCap,
        vesselGears,
        vesselGrabs,
        vesselFlag,
        vesselMMSI,
        vesselClass,
        vesselBalSpd1 = 0,
        vesselBalConsmHS1 = 0,
        vesselBalConsmLS1 = 0,
        vesselBalConsmMGO1 = 0,
        vesselBalSpd2 = 0,
        vesselBalConsmHS2 = 0,
        vesselBalConsmLS2 = 0,
        vesselBalConsmMGO2 = 0,
        vesselBalSpd3 = 0,
        vesselBalConsmHS3 = 0,
        vesselBalConsmLS3 = 0,
        vesselBalConsmMGO3 = 0,
        vesselBalSpd4 = 0,
        vesselBalConsmHS4 = 0,
        vesselBalConsmLS4 = 0,
        vesselBalConsmMGO4 = 0,
        vesselLdnSpd1 = 0,
        vesselLdnConsmHS1 = 0,
        vesselLdnConsmLS1 = 0,
        vesselLdnConsmMGO1 = 0,
        vesselLdnSpd2 = 0,
        vesselLdnConsmHS2 = 0,
        vesselLdnConsmLS2 = 0,
        vesselLdnConsmMGO2 = 0,
        vesselLdnSpd3 = 0,
        vesselLdnConsmHS3 = 0,
        vesselLdnConsmLS3 = 0,
        vesselLdnConsmMGO3 = 0,
        vesselLdnSpd4 = 0,
        vesselLdnConsmHS4 = 0,
        vesselLdnConsmLS4 = 0,
        vesselLdnConsmMGO4 = 0,
        vesselPIdleConsmHS = 0,
        vesselPIdleConsmLS = 0,
        vesselPIdleConsmMGO = 0,
        vesselPLdgConsmHS = 0,
        vesselPLdgConsmLS = 0,
        vesselPLdgConsmMGO = 0,
        vesselPDischConsmHS = 0,
        vesselPDischConsmLS = 0,
        vesselPDischConsmMGO = 0,
        vesselVExtraConsmHS = 0,
        vesselVExtraConsmLS = 0,
        vesselVExtraConsmMGO = 0,
        vesselBalComb1Selected = false,
        vesselBalComb2Selected = false,
        vesselBalComb3Selected = false,
        vesselBalComb4Selected = false,
        vesselLadComb1Selected = false,
        vesselLadComb2Selected = false,
        vesselLadComb3Selected = false,
        vesselLadComb4Selected = false,
        vesselExtraDetails = {},
    } = vessel?.vesseldata || {};

    const {
        _id = "",
        port,
        bnkDelhs = 0,
        bnkDells = 0,
        bnkDelmgo = 0,
        bnkPriceDeliveryhs = 0,
        bnkPriceDeliveryls = 0,
        bnkPriceDeliverymgo = 0,
        bnkPriceRedeliveryhs = 0,
        bnkPriceRedeliveryls = 0,
        bnkPriceRedeliverymgo = 0,
        bnkPriceSettlemenths = 0,
        bnkPriceSettlementls = 0,
        bnkPriceSettlementmgo = 0,
        bnkQtyRedeliveryhs = 0,
        bnkQtyRedeliveryls = 0,
        bnkQtyRedeliverymgo = 0,
        bnkRedeliveryQtyTolerancehs = 0,
        bnkRedeliveryQtyTolerancels = 0,
        bnkRedeliveryQtyTolerancemgo = 0,
        bunkerPriceOverridden = false,
        constants = 0,
        extraExpense = 0,
        bnkFuelMain = '',
        bnkFuelEca = '',
        bnkFuelMgo = ''
    } = vessel || {}
        const splitData = JSON.parse(vessel.splitHire || "[]") || [];

        // Construct the PDF data
        const data = {
            first_section: {
                _id,
                vesselName,
                port,
                remark: vessel.remark,
                DWT: vesselDwt,
                Draft: vesselDraftS,
                TPC: vesselTPC,
                grain: vesselGrainCap,
                built: vesselBuilt,
                LOA: vesselLOA,
                Beam: vesselBeam,
                GRT: vesselGRT,
                NRT: vesselNRT,
                light_ship: vesselLightShip,
                bale_capacity: vesselBaleCap,
                Gears: vesselGears,
                Grabs: vesselGrabs,
                Flag: vesselFlag,
                MMSI: vesselMMSI,
                Class: vesselClass,

            },
            second_section: {
                DWT: vesselDwt,
                IMO: vesselIMO,
                BalComb1: vesselBalComb1Selected,
                BalComb2: vesselBalComb2Selected,
                BalComb3: vesselBalComb3Selected,
                BalComb4: vesselBalComb4Selected,
                LadComb1: vesselLadComb1Selected,
                LadComb2: vesselLadComb2Selected,
                LadComb3: vesselLadComb3Selected,
                LadComb4: vesselLadComb4Selected,
                Ballast_Sea_Consumptions: {
                    col_1: {
                        Speed: vesselBalSpd1,
                        HS: vesselBalConsmHS1,
                        LS: vesselBalConsmLS1,
                        MGO: vesselBalConsmMGO1,
                    },
                    col_2: {
                        Speed: vesselBalSpd2,
                        HS: vesselBalConsmHS2,
                        LS: vesselBalConsmLS2,
                        MGO: vesselBalConsmMGO2,
                    },
                    col_3: {
                        Speed: vesselBalSpd3,
                        HS: vesselBalConsmHS3,
                        LS: vesselBalConsmLS3,
                        MGO: vesselBalConsmMGO3,
                    },
                    col_4: {
                        Speed: vesselBalSpd4,
                        HS: vesselBalConsmHS4,
                        LS: vesselBalConsmLS4,
                        MGO: vesselBalConsmMGO4,
                    },
                },
                Laden_Sea_Consumptions: {
                    col_1: {
                        Speed: vesselLdnSpd1,
                        HS: vesselLdnConsmHS1,
                        LS: vesselLdnConsmLS1,
                        MGO: vesselLdnConsmMGO1,
                    },
                    col_2: {
                        Speed: vesselLdnSpd2,
                        HS: vesselLdnConsmHS2,
                        LS: vesselLdnConsmLS2,
                        MGO: vesselLdnConsmMGO2,
                    },
                    col_3: {
                        Speed: vesselLdnSpd3,
                        HS: vesselLdnConsmHS3,
                        LS: vesselLdnConsmLS3,
                        MGO: vesselLdnConsmMGO3,
                    },
                    col_4: {
                        Speed: vesselLdnSpd4,
                        HS: vesselLdnConsmHS4,
                        LS: vesselLdnConsmLS4,
                        MGO: vesselLdnConsmMGO4,
                    },
                },
                Port_Consumptions: {
                    Idle: {
                        HS: vesselPIdleConsmHS,
                        LS: vesselPIdleConsmLS,
                        MGO: vesselPIdleConsmMGO,
                    },
                    Loading: {
                        HS: vesselPLdgConsmHS,
                        LS: vesselPLdgConsmLS,
                        MGO: vesselPLdgConsmMGO,
                    },
                    Disch: {
                        HS: vesselPDischConsmHS,
                        LS: vesselPDischConsmLS,
                        MGO: vesselPDischConsmMGO,
                    },
                    Extra: {
                        HS: vesselVExtraConsmHS,
                        LS: vesselVExtraConsmLS,
                        MGO: vesselVExtraConsmMGO,
                    },
                },
            },
            third_section: {
                split_hire: splitData || [],
                bunker_qty: {
                    bnkDelhs,
                    bnkDells,
                    bnkDelmgo,
                    bnkQtyRedeliveryhs,
                    bnkQtyRedeliveryls,
                    bnkQtyRedeliverymgo,
                    bnkRedeliveryQtyTolerancehs,
                    bnkRedeliveryQtyTolerancels,
                    bnkRedeliveryQtyTolerancemgo,
                },
                bunker_price: {
                    bnkPriceDeliveryhs,
                    bnkPriceDeliveryls,
                    bnkPriceDeliverymgo,
                    bnkPriceRedeliveryhs,
                    bnkPriceRedeliveryls,
                    bnkPriceRedeliverymgo,
                    bnkPriceSettlemenths,
                    bnkPriceSettlementls,
                    bnkPriceSettlementmgo,
                }

            },
            fourth_section: {
                extraExpense,
                constants,
                dateOpen: vessel.dateOpen,
                Gbb: vessel.gbb,
                hirePerDay: vessel.hirePerDay,
                hireGbb: vessel.hireGbb,
            }
        };

        return data;
};

function EditVesselOnFleetAddStep(props) {
    const { type = "update", setLoader = () => { }, setValidationVesselFromAuto = () => { }, onSubmitVessel, setAddFleetsArray = () => { }, addFleetsArray, onValidationVesselIndex = 0, onClickAddFleet = () => { }, isFromCreateVessel = false } = props;
    const [vessel, setVessel] = useState({});
    const [pdfData, setPdfData] = useState([])
    const [isOverride, setIsOverride] = useState(false);
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();
    const [warningPopup, setWarningPopup] = useState({
        isOpen: false,
        data: null
    });
    const dispatch = useDispatch();
    const [portOptions, setPortOptions] = useState([]);
    const latestPortQuery = useRef("");
    const searchPorts = useMemo(() => _.debounce((q) => {
        if (!q) return;
        calculatorActions.portsByChar(q).then((res) => {
            if (latestPortQuery.current !== q) return;
            const list = (res && res.data && res.data.list) || [];
            setPortOptions(list.map((i) => ({ ...i, portLabel: `${i.name} ${i.country ? "(" + i.country + ")" : ""}` })));
        }).catch(() => { });
    }, 500), []);
    const onOpenErrorAlert = (errors = []) => {
        dispatch(commonActions.openErrorAlert({ errorList: errors }));
    };
    const handleNext = () => {
        const error = checkValidation(vessel, vessel?.vesseldata, activeStep)
        if (error?.length) {
            return onOpenErrorAlert(error);
        }
        if (activeStep !== 4) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }

        onSubmitUpdateVessel()
        if (activeStep === 4 && window.handleVesselTourAction) {
            window.handleVesselTourAction('modal_next_clicked');
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    useEffect(() => {
        // setVessel(addFleetsArray[onValidationVesselIndex]);
        setVessel({ ...initialVessel, vesseldata: { ...initialRowData, ...addFleetsArray[onValidationVesselIndex]?.vesseldata }, ...addFleetsArray[onValidationVesselIndex] });
    }, []);

    const onChangeHandler = (e, isExtra = false, isCheckbox) => {
        const { name = "", value = "", checked } = e.target;
        const updatedVessel = { ...vessel };
        const { vesselExtraDetails = {} } = updatedVessel?.vesseldata;

        if (isExtra) {
            vesselExtraDetails[name] = isCheckbox ? checked : value;
        } else {
            updatedVessel.vesseldata[name] = isCheckbox ? checked : value;
        }
        setVessel({
            ...updatedVessel,
            vesselExtraDetails: {
                ...vesselExtraDetails,
            },
        });
    };

    const onChangeBunkerFuelHandler = (e) => {
        const { name = "", value = "" } = e.target;
        const updatedVessel = { ...vessel };
        updatedVessel[name] = value;
        setVessel(updatedVessel);
    };


    const onSubmitUpdateVessel = () => {
        if (vessel?.vesseldata) {
            let updatedVal = [...addFleetsArray]
            updatedVal[onValidationVesselIndex] = vessel
            if (activeStep === 4) {
                updatedVal[onValidationVesselIndex].isValidate = true;
                if (type === "update") {
                    setWarningPopup({
                        isOpen: true,
                        data: updatedVal
                    });
                } else {
                    onSubmitVessel(updatedVal);
                }
            }
            setAddFleetsArray(updatedVal);
        }
    };


    const {

        vesselName = "",
        vesselDwt = 0,
        vesselIMO = 0,
        vesselDraftS = 0,
        vesselTPC,
        vesselGrainCap,
        vesselBuilt,
        vesselLOA,
        vesselBeam,
        vesselGRT,
        vesselNRT,
        vesselLightShip,
        vesselBaleCap,
        vesselGears,
        vesselGrabs,
        vesselFlag,
        vesselMMSI,
        vesselClass,
        vesselBalSpd1 = 0,
        vesselBalConsmHS1 = 0,
        vesselBalConsmLS1 = 0,
        vesselBalConsmMGO1 = 0,
        vesselBalSpd2 = 0,
        vesselBalConsmHS2 = 0,
        vesselBalConsmLS2 = 0,
        vesselBalConsmMGO2 = 0,
        vesselBalSpd3 = 0,
        vesselBalConsmHS3 = 0,
        vesselBalConsmLS3 = 0,
        vesselBalConsmMGO3 = 0,
        vesselBalSpd4 = 0,
        vesselBalConsmHS4 = 0,
        vesselBalConsmLS4 = 0,
        vesselBalConsmMGO4 = 0,
        vesselLdnSpd1 = 0,
        vesselLdnConsmHS1 = 0,
        vesselLdnConsmLS1 = 0,
        vesselLdnConsmMGO1 = 0,
        vesselLdnSpd2 = 0,
        vesselLdnConsmHS2 = 0,
        vesselLdnConsmLS2 = 0,
        vesselLdnConsmMGO2 = 0,
        vesselLdnSpd3 = 0,
        vesselLdnConsmHS3 = 0,
        vesselLdnConsmLS3 = 0,
        vesselLdnConsmMGO3 = 0,
        vesselLdnSpd4 = 0,
        vesselLdnConsmHS4 = 0,
        vesselLdnConsmLS4 = 0,
        vesselLdnConsmMGO4 = 0,
        vesselPIdleConsmHS = 0,
        vesselPIdleConsmLS = 0,
        vesselPIdleConsmMGO = 0,
        vesselPLdgConsmHS = 0,
        vesselPLdgConsmLS = 0,
        vesselPLdgConsmMGO = 0,
        vesselPDischConsmHS = 0,
        vesselPDischConsmLS = 0,
        vesselPDischConsmMGO = 0,
        vesselVExtraConsmHS = 0,
        vesselVExtraConsmLS = 0,
        vesselVExtraConsmMGO = 0,
        vesselBalComb1Selected = false,
        vesselBalComb2Selected = false,
        vesselBalComb3Selected = false,
        vesselBalComb4Selected = false,
        vesselLadComb1Selected = false,
        vesselLadComb2Selected = false,
        vesselLadComb3Selected = false,
        vesselLadComb4Selected = false,
        vesselExtraDetails = {},
    } = vessel?.vesseldata || {};


    const addNewSplitHire = () => {
        let splitHire =
            (vessel &&
                vessel.splitHire &&
                JSON.parse(vessel.splitHire)) ||
            [];
        if (!!splitHire.find((item) => item.NoDays === 0)) return;
        splitHire.push({ NoDays: 0, applied: 0, disable: false, hireRate: 0 });
        setVessel({
            ...vessel,
            splitHire: JSON.stringify(splitHire),
        });
    };
    const onChangeSplitHire = (index, e, isDelete = false) => {
        let splitHire =
            (vessel &&
                vessel.splitHire &&
                JSON.parse(vessel.splitHire)) ||
            [];
        if (isDelete) splitHire.splice(index, 1);
        else {
            const { name = "", value = "" } = e.target;
            splitHire[index][name] = Number(value);
        }
        const udpatedvessel = {
            ...vessel,
            splitHire: JSON.stringify(splitHire),
        };
        setVessel(udpatedvessel);
    };

    const onChangeSelectedVessel = (e, fieldname = false, isDate = false) => {
        let {
            name = "",
            value = "",
        } = e.target || {};
        if (isDate) {
            value = e
            name = fieldname
        }
        let newUpdatedFleet = { ...vessel };
        newUpdatedFleet[name] = value;
        setVessel(newUpdatedFleet);
    };
    const onChangeBunkerPriceOverridden = (e) => {
        let {
            name = "",
            checked = "",
        } = e.target || {};
        let newUpdatedFleet = { ...vessel };
        newUpdatedFleet[name] = checked;
        setVessel(newUpdatedFleet);
    }
    const {
        _id = "",
        port,
        bnkDelhs = 0,
        bnkDells = 0,
        bnkDelmgo = 0,
        bnkPriceDeliveryhs = 0,
        bnkPriceDeliveryls = 0,
        bnkPriceDeliverymgo = 0,
        bnkPriceRedeliveryhs = 0,
        bnkPriceRedeliveryls = 0,
        bnkPriceRedeliverymgo = 0,
        bnkPriceSettlemenths = 0,
        bnkPriceSettlementls = 0,
        bnkPriceSettlementmgo = 0,
        bnkQtyRedeliveryhs = 0,
        bnkQtyRedeliveryls = 0,
        bnkQtyRedeliverymgo = 0,
        bnkRedeliveryQtyTolerancehs = 0,
        bnkRedeliveryQtyTolerancels = 0,
        bnkRedeliveryQtyTolerancemgo = 0,
        bunkerPriceOverridden = false,
        constants = 0,
        extraExpense = 0,
        bnkFuelMain = '',
        bnkFuelEca = '',
        bnkFuelMgo = ''
    } = vessel || {}
    function getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return <Grid item xs={12} md={6} style={{ padding: "0 6px 0 0" }}>
                    <Grid container>
                                {/* <Grid item xs={12}>
                                <div className="d-flex">
                                    <h4 className="result-heading" style={{ textDecoration: "underline" }}><Link to={`/vessel/${vessel.id}`} target="_blank" >Vessel Details</Link></h4>
                                    <div><button color="primary" className="add-vessel-calculator" onClick={() => setOpen(true)}>+</button></div>
                                </div>
                            </Grid> */}

                                <Grid item xs={12}>
                                    <div className="flex items-center gap-3 w-full mb-2">
                                        <div className="flex items-center gap-1.5 flex-1 min-w-0">
                                            <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">Vessel</span>
                                            <input
                                                disabled={true}
                                                value={vesselName}
                                                type="text"
                                                name="vesselName"
                                                className="h-[24px] px-1.5 text-[11px] font-medium bg-slate-100 border border-slate-300 w-full outline-none"
                                                onChange={onChangeHandler}
                                            />
                                        </div>
                                        <div className="flex items-center gap-1.5 w-[85px] shrink-0">
                                            <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">Dwt</span>
                                            <input
                                                disabled={!isFromCreateVessel}
                                                value={vesselDwt}
                                                name="vesselDwt"
                                                className="h-[24px] px-1.5 text-[11px] font-medium bg-[#ffffd6] border border-slate-300 w-full outline-none disabled:bg-slate-100"
                                                onChange={onChangeHandler}
                                            />
                                        </div>
                                        <div className="flex items-center gap-1.5 w-[85px] shrink-0">
                                            <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">IMO</span>
                                            <input
                                                disabled={!isFromCreateVessel}
                                                value={vesselIMO}
                                                name="vesselIMO"
                                                className="h-[24px] px-1.5 text-[11px] font-medium bg-[#ffffd6] border border-slate-300 w-full outline-none disabled:bg-slate-100"
                                                onChange={onChangeHandler}
                                            />
                                        </div>
                                    </div>
                                </Grid>

                                <Grid item xs={12} md={5} className="md:pr-1.5 mb-3 md:mb-0">
                                    <table className="fleet-result-table vesselDetails">
                                        <tbody>
                                            {vesselCalculatorMainFields.map((item, key) => {
                                                if (
                                                    item.name === "fuelType" ||
                                                    item.name === "vesselScrubber"
                                                )
                                                    return null;
                                                return (
                                                    <tr key={key}>
                                                        <th>{item.label}</th>
                                                        <td>
                                                            <input
                                                                value={vessel?.vesseldata?.[item.name] || ""}
                                                                type={item.type}
                                                                onKeyDown={handleKeyDown}
                                                                name={item.name}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </Grid>
                                <Grid item xs={12} md={7} className="md:pl-1.5">
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <p className="mt-0 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                Ballast Sea Consumptions
                                            </p>
                                            <table className="vessel-details-tables">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Speed</th>
                                                        <th>Main</th>
                                                        <th>ECA</th>
                                                        <th>MGO</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="input-type-checkbox"
                                                                name="vesselBalComb1Selected"
                                                                checked={vesselBalComb1Selected || false}
                                                                onChange={(e) => onChangeHandler(e, false, true)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalSpd1"
                                                                value={vesselBalSpd1 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmHS1"
                                                                value={vesselBalConsmHS1 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmLS1"
                                                                value={vesselBalConsmLS1 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmMGO1"
                                                                value={vesselBalConsmMGO1 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="input-type-checkbox"
                                                                name="vesselBalComb2Selected"
                                                                checked={vesselBalComb2Selected || false}
                                                                // onChange={onChangeHandler}
                                                                onChange={(e) => onChangeHandler(e, false, true)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalSpd2"
                                                                value={vesselBalSpd2 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmHS2"
                                                                value={vesselBalConsmHS2 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmLS2"
                                                                value={vesselBalConsmLS2 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmMGO2"
                                                                value={vesselBalConsmMGO2 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="input-type-checkbox"
                                                                name="vesselBalComb3Selected"
                                                                checked={vesselBalComb3Selected || false}
                                                                // onChange={onChangeHandler}
                                                                onChange={(e) => onChangeHandler(e, false, true)}

                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalSpd3"
                                                                value={vesselBalSpd3 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmHS3"
                                                                value={vesselBalConsmHS3 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmLS3"
                                                                value={vesselBalConsmLS3 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmMGO3"
                                                                value={vesselBalConsmMGO3 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="input-type-checkbox"
                                                                name="vesselBalComb4Selected"
                                                                checked={vesselBalComb4Selected || false}
                                                                // onChange={onChangeHandler}
                                                                onChange={(e) => onChangeHandler(e, false, true)}

                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalSpd4"
                                                                value={vesselBalSpd4 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmHS4"
                                                                value={vesselBalConsmHS4 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmLS4"
                                                                value={vesselBalConsmLS4 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselBalConsmMGO4"
                                                                value={vesselBalConsmMGO4 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <p className="mt-3 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                Laden Sea Consumptions
                                            </p>
                                            <table className="vessel-details-tables">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Speed</th>
                                                        <th>Main</th>
                                                        <th>ECA</th>
                                                        <th>MGO</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="input-type-checkbox"
                                                                name="vesselLadComb1Selected"
                                                                checked={vesselLadComb1Selected || false}
                                                                // onChange={onChangeHandler}
                                                                onChange={(e) => onChangeHandler(e, false, true)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnSpd1"
                                                                value={vesselLdnSpd1 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmHS1"
                                                                value={vesselLdnConsmHS1 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmLS1"
                                                                value={vesselLdnConsmLS1 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmMGO1"
                                                                value={vesselLdnConsmMGO1 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="input-type-checkbox"
                                                                name="vesselLadComb2Selected"
                                                                checked={vesselLadComb2Selected || false}
                                                                // onChange={onChangeHandler}
                                                                onChange={(e) => onChangeHandler(e, false, true)}

                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnSpd2"
                                                                value={vesselLdnSpd2 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmHS2"
                                                                value={vesselLdnConsmHS2 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmLS2"
                                                                value={vesselLdnConsmLS2 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmMGO2"
                                                                value={vesselLdnConsmMGO2 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="input-type-checkbox"
                                                                name="vesselLadComb3Selected"
                                                                checked={vesselLadComb3Selected || false}
                                                                // onChange={onChangeHandler}
                                                                onChange={(e) => onChangeHandler(e, false, true)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnSpd3"
                                                                value={vesselLdnSpd3 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmHS3"
                                                                value={vesselLdnConsmHS3 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmLS3"
                                                                value={vesselLdnConsmLS3 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmMGO3"
                                                                value={vesselLdnConsmMGO3 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                className="input-type-checkbox"
                                                                name="vesselLadComb4Selected"
                                                                checked={vesselLadComb4Selected || false}
                                                                // onChange={onChangeHandler}
                                                                onChange={(e) => onChangeHandler(e, false, true)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnSpd4"
                                                                value={vesselLdnSpd4 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmHS4"
                                                                value={vesselLdnConsmHS4 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmLS4"
                                                                value={vesselLdnConsmLS4 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselLdnConsmMGO4"
                                                                value={vesselLdnConsmMGO4 || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <p className="mt-3 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                Port Consumptions
                                            </p>
                                            <table className="vessel-details-tables">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Main</th>
                                                        <th>ECA</th>
                                                        <th>MGO</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th>Idle</th>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPIdleConsmHS"
                                                                value={vesselPIdleConsmHS || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPIdleConsmLS"
                                                                value={vesselPIdleConsmLS || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPIdleConsmMGO"
                                                                value={vesselPIdleConsmMGO || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Loading</th>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPLdgConsmHS"
                                                                value={vesselPLdgConsmHS || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPLdgConsmLS"
                                                                value={vesselPLdgConsmLS || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPLdgConsmMGO"
                                                                value={vesselPLdgConsmMGO || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Disch</th>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPDischConsmHS"
                                                                value={vesselPDischConsmHS || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPDischConsmLS"
                                                                value={vesselPDischConsmLS || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselPDischConsmMGO"
                                                                value={vesselPDischConsmMGO || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <Tooltip placement="top" arrow title={<span className="text-sm">Any Additional Lupsum Consumption in the entire voyage</span>}>
                                                            <th>Extra</th>
                                                        </Tooltip>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselVExtraConsmHS"
                                                                value={vesselVExtraConsmHS || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselVExtraConsmLS"
                                                                value={vesselVExtraConsmLS || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                onKeyDown={handleKeyDown}
                                                                placeholder="0"
                                                                name="vesselVExtraConsmMGO"
                                                                value={vesselVExtraConsmMGO || ""}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
            case 1:
                return <Grid item xs={12} md={4} style={{ padding: "0 6px", margin: "0 auto" }}>
                    <Grid item xs={12} md={12} style={{ marginTop: "8px" }}>
                        <div className="w-full">
                            <table className="fleet-result-table w-full">
                                <thead>
                                    <tr>
                                        <th style={{ width: "38%" }}>Bunker Qty</th>
                                        <th style={{ width: "20%" }}>Main</th>
                                        <th style={{ width: "20%" }}>ECA</th>
                                        <th style={{ width: "22%" }}>MGO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>On Delivery</th>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkDelhs} name="bnkDelhs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkDells} name="bnkDells" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkDelmgo} name="bnkDelmgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                    </tr>
                                    <tr>
                                        <th>Exp on Re-Delivery</th>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliveryhs} name="bnkQtyRedeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliveryls} name="bnkQtyRedeliveryls" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliverymgo} name="bnkQtyRedeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                    </tr>
                                    <tr>
                                        <th>Tolerance Acceptable</th>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancehs} name="bnkRedeliveryQtyTolerancehs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancels} name="bnkRedeliveryQtyTolerancels" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancemgo} name="bnkRedeliveryQtyTolerancemgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={12} style={{ marginTop: "2px", marginBottom: "2px", display: "flex", justifyContent: "flex-end" }}>
                        <div style={{ marginBottom: 0 }} className="sync-bunker-switch">
                            <label>Override</label>
                            <Switch
                                checked={bunkerPriceOverridden}
                                onChange={e => onChangeBunkerPriceOverridden(e)}
                                name="bunkerPriceOverridden"
                                color="primary"
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <div className="w-full">
                            <table className="fleet-result-table w-full">
                                <thead>
                                    <tr>
                                        <th style={{ width: "38%" }}>Bunker Prices</th>
                                        <th style={{ width: "20%" }}>Main</th>
                                        <th style={{ width: "20%" }}>ECA</th>
                                        <th style={{ width: "22%" }}>MGO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>On Delivery</th>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceDeliveryhs}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliveryhs} disabled={!bunkerPriceOverridden} name="bnkPriceDeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceDeliveryls}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliveryls} disabled={!bunkerPriceOverridden} name="bnkPriceDeliveryls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceDeliverymgo}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliverymgo} disabled={!bunkerPriceOverridden} name="bnkPriceDeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                    </tr>
                                    <tr>
                                        <th>On Re-Delivery</th>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceRedeliveryhs}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliveryhs} name="bnkPriceRedeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceRedeliveryls}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliveryls} name="bnkPriceRedeliveryls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceRedeliverymgo}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliverymgo} name="bnkPriceRedeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                    </tr>
                                    <tr>
                                        <th>For Settlement</th>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceSettlemenths}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlemenths} name="bnkPriceSettlemenths" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceSettlementls}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlementls} name="bnkPriceSettlementls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        <td>{!bunkerPriceOverridden ? <p>{bnkPriceSettlementmgo}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlementmgo} name="bnkPriceSettlementmgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="mt-2.5">
                        <table className="fleet-result-table w-full">
                            <thead>
                                <tr>
                                    <th colSpan="2" style={{ background: "#f1f5f9", color: "#334155" }}>
                                        Bunker Fuel specifications
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th style={{ width: "38%" }}>Main</th>
                                    <td>
                                        <Tooltip
                                            title={<span className="text-xs">{bnkFuelMain || 'empty'}</span>}
                                            placement="top"
                                            arrow
                                        >
                                            <input
                                                name="bnkFuelMain"
                                                type="text"
                                                maxLength={100}
                                                placeholder=""
                                                value={bnkFuelMain || ''}
                                                onChange={onChangeBunkerFuelHandler}
                                            />
                                        </Tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <th>ECA</th>
                                    <td>
                                        <Tooltip
                                            title={<span className="text-xs">{bnkFuelEca || 'empty'}</span>}
                                            placement="top"
                                            arrow
                                        >
                                            <input
                                                name="bnkFuelEca"
                                                type="text"
                                                maxLength={100}
                                                placeholder=""
                                                value={bnkFuelEca || ''}
                                                onChange={onChangeBunkerFuelHandler}
                                            />
                                        </Tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <th>MDO</th>
                                    <td>
                                        <Tooltip
                                            title={<span className="text-xs">{bnkFuelMgo || 'empty'}</span>}
                                            placement="top"
                                            arrow
                                        >
                                            <input
                                                name="bnkFuelMgo"
                                                type="text"
                                                maxLength={100}
                                                placeholder=""
                                                value={bnkFuelMgo || ''}
                                                onChange={onChangeBunkerFuelHandler}
                                            />
                                        </Tooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Grid>
                </Grid>
            case 2:
                return <Grid item xs={12} md={4} style={{ padding: "0 6px" }}>
                    <Grid item xs={12} md={12}>
                        <div className="mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">Split hire</div>
                        <SplitHireModal
                            addNewSplitHire={addNewSplitHire}
                            selectedSplitHire={vessel}
                            onChangeSplitHire={onChangeSplitHire}
                        />
                    </Grid>
                </Grid>

            case 3:
                return <Grid item xs={12} md={4} style={{ padding: "0 6px", margin: "0 auto" }}>
                    <Grid item xs={12} md={12} style={{ marginTop: "8px" }}>
                        <table className="fleet-result-table w-full" style={{ marginBottom: "10px" }}>
                            <tbody>
                                <tr>
                                    <th style={{ width: "38%" }}>Extra Expenses</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            placeholder="0"
                                            onChange={(e) => onChangeSelectedVessel(e, true)}
                                            value={
                                                extraExpense
                                            }
                                            name="extraExpense"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Constants</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            placeholder="0"
                                            onChange={(e) => onChangeSelectedVessel(e, true)}
                                            value={
                                                constants
                                            }
                                            name="constants"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Grid>
                    <Grid item xs={12} md={12} style={{ marginTop: "10px" }}>
                        <table className="fleet-result-table w-full">
                            <tbody>
                                <tr>
                                    <th style={{ width: "38%" }}>Date Opening</th>
                                    <td>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DateTimePicker
                                                inputVariant="outlined"
                                                size="small"
                                                name="dateOpen"
                                                className="date-time-picker-update-fleet"
                                                style={{ width: "100%", background: "#ffffd6" }}
                                                value={(vessel && vessel.dateOpen) || Date.now()}
                                                onChange={(date) =>
                                                    onChangeSelectedVessel(date, "dateOpen", true)
                                                }
                                            />
                                        </MuiPickersUtilsProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Hire Per Day</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            value={(vessel && vessel.hirePerDay) || 0}
                                            name="hirePerDay"
                                            className="custom-input-field"
                                            onChange={(e) =>
                                                onChangeSelectedVessel(
                                                    e,
                                                    true
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Hire GBB</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            value={(vessel && vessel.hireGbb) || 0}
                                            name="hireGbb"
                                            className="custom-input-field"
                                            onChange={(e) =>
                                                onChangeSelectedVessel(
                                                    e,
                                                    true
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Grid>
                </Grid>
            case 4:
                return <Grid container>
                    <Grid item xs={12} md={6} style={{ padding: "0 6px 0 0" }}>
                        <Grid container>
                                    {/* <Grid item xs={12}>
                                    <div className="d-flex">
                                        <h4 className="result-heading" style={{ textDecoration: "underline" }}><Link to={`/vessel/${vessel.id}`} target="_blank" >Vessel Details</Link></h4>
                                        <div><button color="primary" className="add-vessel-calculator" onClick={() => setOpen(true)}>+</button></div>
                                    </div>
                                </Grid> */}

                                    <Grid item xs={12}>
                                        <div className="grid grid-cols-[2fr_1fr_1fr] gap-3 w-full mb-3">
                                            <div className="flex items-center gap-1.5 min-w-0">
                                                <span className="text-[11px] font-medium text-slate-700 whitespace-nowrap">Vessel</span>
                                                <input
                                                    disabled={true}
                                                    value={vesselName}
                                                    type="text"
                                                    name="vesselName"
                                                    className="h-[24px] px-1.5 text-[11px] font-medium bg-slate-100 border border-slate-300 w-full outline-none"
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                            <div className="flex items-center gap-1.5 min-w-0">
                                                <span className="text-[11px] font-medium text-slate-700 whitespace-nowrap">DWT</span>
                                                <input
                                                    disabled={!isFromCreateVessel}
                                                    value={vesselDwt}
                                                    name="vesselDwt"
                                                    className="h-[24px] px-1.5 text-[11px] font-medium bg-[#ffffd6] border border-slate-300 w-full outline-none disabled:bg-slate-100"
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                            <div className="flex items-center gap-1.5 min-w-0">
                                                <span className="text-[11px] font-medium text-slate-700 whitespace-nowrap">IMO</span>
                                                <input
                                                    disabled={!isFromCreateVessel}
                                                    value={vesselIMO}
                                                    name="vesselIMO"
                                                    className="h-[24px] px-1.5 text-[11px] font-medium bg-[#ffffd6] border border-slate-300 w-full outline-none disabled:bg-slate-100"
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} md={5} className="md:pr-1.5 mb-3 md:mb-0">
                                        <p className="mt-0 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                            Vessel Particulars
                                        </p>
                                        <table className="fleet-result-table vesselDetails !w-full">
                                            <tbody>
                                                {vesselCalculatorMainFields.map((item, key) => {
                                                    if (
                                                        item.name === "fuelType" ||
                                                        item.name === "vesselScrubber"
                                                    )
                                                        return null;
                                                    return (
                                                        <tr key={key}>
                                                            <th>{item.label}</th>
                                                            <td>
                                                                <input
                                                                    value={vessel?.vesseldata?.[item.name] || ""}
                                                                    type={item.type}
                                                                    onKeyDown={handleKeyDown}
                                                                    name={item.name}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Grid>
                                    <Grid item xs={12} md={7} className="md:pl-1.5">
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <p className="mt-0 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Ballast Sea Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Speed</th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb1Selected"
                                                                    checked={vesselBalComb1Selected || false}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd1"
                                                                    value={vesselBalSpd1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS1"
                                                                    value={vesselBalConsmHS1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS1"
                                                                    value={vesselBalConsmLS1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO1"
                                                                    value={vesselBalConsmMGO1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb2Selected"
                                                                    checked={vesselBalComb2Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd2"
                                                                    value={vesselBalSpd2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS2"
                                                                    value={vesselBalConsmHS2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS2"
                                                                    value={vesselBalConsmLS2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO2"
                                                                    value={vesselBalConsmMGO2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb3Selected"
                                                                    checked={vesselBalComb3Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd3"
                                                                    value={vesselBalSpd3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS3"
                                                                    value={vesselBalConsmHS3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS3"
                                                                    value={vesselBalConsmLS3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO3"
                                                                    value={vesselBalConsmMGO3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb4Selected"
                                                                    checked={vesselBalComb4Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd4"
                                                                    value={vesselBalSpd4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS4"
                                                                    value={vesselBalConsmHS4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS4"
                                                                    value={vesselBalConsmLS4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO4"
                                                                    value={vesselBalConsmMGO4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <p className="mt-3 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Laden Sea Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Speed</th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb1Selected"
                                                                    checked={vesselLadComb1Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd1"
                                                                    value={vesselLdnSpd1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS1"
                                                                    value={vesselLdnConsmHS1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS1"
                                                                    value={vesselLdnConsmLS1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO1"
                                                                    value={vesselLdnConsmMGO1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb2Selected"
                                                                    checked={vesselLadComb2Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd2"
                                                                    value={vesselLdnSpd2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS2"
                                                                    value={vesselLdnConsmHS2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS2"
                                                                    value={vesselLdnConsmLS2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO2"
                                                                    value={vesselLdnConsmMGO2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb3Selected"
                                                                    checked={vesselLadComb3Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd3"
                                                                    value={vesselLdnSpd3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS3"
                                                                    value={vesselLdnConsmHS3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS3"
                                                                    value={vesselLdnConsmLS3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO3"
                                                                    value={vesselLdnConsmMGO3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb4Selected"
                                                                    checked={vesselLadComb4Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd4"
                                                                    value={vesselLdnSpd4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS4"
                                                                    value={vesselLdnConsmHS4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS4"
                                                                    value={vesselLdnConsmLS4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO4"
                                                                    value={vesselLdnConsmMGO4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <p className="mt-3 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Port Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th>Idle</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmHS"
                                                                    value={vesselPIdleConsmHS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmLS"
                                                                    value={vesselPIdleConsmLS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmMGO"
                                                                    value={vesselPIdleConsmMGO || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Loading</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmHS"
                                                                    value={vesselPLdgConsmHS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmLS"
                                                                    value={vesselPLdgConsmLS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmMGO"
                                                                    value={vesselPLdgConsmMGO || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Disch</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmHS"
                                                                    value={vesselPDischConsmHS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmLS"
                                                                    value={vesselPDischConsmLS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmMGO"
                                                                    value={vesselPDischConsmMGO || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <Tooltip placement="top" arrow title={<span className="text-sm">Any Additional Lupsum Consumption in the entire voyage</span>}>
                                                                <th>Extra</th>
                                                            </Tooltip>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmHS"
                                                                    value={vesselVExtraConsmHS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmLS"
                                                                    value={vesselVExtraConsmLS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmMGO"
                                                                    value={vesselVExtraConsmMGO || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                    <Grid item xs={12} md={3} style={{ padding: "0 6px" }}>
                        <Grid item xs={12} md={12}>
                            <div className="mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                Split hire
                            </div>
                            <SplitHireModal
                                addNewSplitHire={addNewSplitHire}
                                selectedSplitHire={vessel}
                                onChangeSplitHire={onChangeSplitHire}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} className="mt-3">
                            <div className="mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                Bunker Quantities
                            </div>
                            <div className="w-full">
                                <table className="fleet-result-table w-full">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "38%" }}>Bunker Qty</th>
                                            <th style={{ width: "20%" }}>Main</th>
                                            <th style={{ width: "20%" }}>ECA</th>
                                            <th style={{ width: "22%" }}>MGO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>On Delivery</th>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkDelhs} name="bnkDelhs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkDells} name="bnkDells" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkDelmgo} name="bnkDelmgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        </tr>
                                        <tr>
                                            <th>Exp on Re-Delivery</th>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliveryhs} name="bnkQtyRedeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliveryls} name="bnkQtyRedeliveryls" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliverymgo} name="bnkQtyRedeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        </tr>
                                        <tr>
                                            <th>Tolerance Acceptable</th>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancehs} name="bnkRedeliveryQtyTolerancehs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancels} name="bnkRedeliveryQtyTolerancels" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancemgo} name="bnkRedeliveryQtyTolerancemgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} className="mt-3 mb-1 flex items-center justify-between">
                            <div className="text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                Bunker Prices
                            </div>
                            <div style={{ marginBottom: 0 }} className="sync-bunker-switch">
                                <label>Override</label>
                                <Switch
                                    checked={bunkerPriceOverridden}
                                    onChange={e => onChangeBunkerPriceOverridden(e)}
                                    name="bunkerPriceOverridden"
                                    color="primary"
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <div className="w-full">
                                <table className="fleet-result-table w-full">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "38%" }}>Bunker Prices</th>
                                            <th style={{ width: "20%" }}>Main</th>
                                            <th style={{ width: "20%" }}>ECA</th>
                                            <th style={{ width: "22%" }}>MGO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>On Delivery</th>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceDeliveryhs}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliveryhs} disabled={!bunkerPriceOverridden} name="bnkPriceDeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceDeliveryls}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliveryls} disabled={!bunkerPriceOverridden} name="bnkPriceDeliveryls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceDeliverymgo}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliverymgo} disabled={!bunkerPriceOverridden} name="bnkPriceDeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        </tr>
                                        <tr>
                                            <th>On Re-Delivery</th>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceRedeliveryhs}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliveryhs} name="bnkPriceRedeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceRedeliveryls}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliveryls} name="bnkPriceRedeliveryls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceRedeliverymgo}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliverymgo} name="bnkPriceRedeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        </tr>
                                        <tr>
                                            <th>For Settlement</th>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceSettlemenths}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlemenths} name="bnkPriceSettlemenths" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceSettlementls}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlementls} name="bnkPriceSettlementls" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td>{!bunkerPriceOverridden ? <p>{bnkPriceSettlementmgo}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlementmgo} name="bnkPriceSettlementmgo" onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                        <Grid item xs={12} className="mt-3">
                            <div className="mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                Bunker Fuel Specifications
                            </div>
                            <table className="fleet-result-table w-full">
                                <tbody>
                                    <tr>
                                        <th style={{ width: "38%" }}>Main</th>
                                        <td>
                                            <Tooltip
                                                title={<span className="text-xs">{bnkFuelMain || 'empty'}</span>}
                                                placement="top"
                                                arrow
                                            >
                                                <input
                                                    name="bnkFuelMain"
                                                    type="text"
                                                    maxLength={100}
                                                    placeholder=""
                                                    value={bnkFuelMain || ''}
                                                    onChange={onChangeBunkerFuelHandler}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>ECA</th>
                                        <td>
                                            <Tooltip
                                                title={<span className="text-xs">{bnkFuelEca || 'empty'}</span>}
                                                placement="top"
                                                arrow
                                            >
                                                <input
                                                    name="bnkFuelEca"
                                                    type="text"
                                                    maxLength={100}
                                                    placeholder=""
                                                    value={bnkFuelEca || ''}
                                                    onChange={onChangeBunkerFuelHandler}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>MDO</th>
                                        <td>
                                            <Tooltip
                                                title={<span className="text-xs">{bnkFuelMgo || 'empty'}</span>}
                                                placement="top"
                                                arrow
                                            >
                                                <input
                                                    name="bnkFuelMgo"
                                                    type="text"
                                                    maxLength={100}
                                                    placeholder=""
                                                    value={bnkFuelMgo || ''}
                                                    onChange={onChangeBunkerFuelHandler}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3} style={{ padding: "0 0 0 6px" }}>
                        <Grid item xs={12} md={12}>
                            <div className="mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                Expenses &amp; Constants
                            </div>
                            <table className="fleet-result-table w-full">
                                <tbody>
                                    <tr>
                                        <th>Extra Expenses</th>
                                        <td>
                                            <input
                                                type="number"
                                                onKeyDown={handleKeyDown}
                                                placeholder="0"
                                                onChange={(e) => onChangeSelectedVessel(e, true)}
                                                value={
                                                    (vessel && vessel.extraExpense) || 0
                                                }
                                                name="extraExpense"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Constants</th>
                                        <td>
                                            <input
                                                type="number"
                                                onKeyDown={handleKeyDown}
                                                placeholder="0"
                                                onChange={(e) => onChangeSelectedVessel(e, true)}
                                                value={
                                                    (vessel && vessel.constants) || 0
                                                }
                                                name="constants"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Grid>
                        <Grid item xs={12} md={12} className="mt-3">
                            <div className="mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                Opening &amp; Hire
                            </div>
                            <table className="fleet-result-table w-full">
                                <tbody>
                                    <tr>
                                        <th>Opening Port</th>
                                        <td>
                                            <Autocomplete
                                                freeSolo
                                                disableClearable
                                                fullWidth
                                                className={classes.portCell}
                                                PopperComponent={WidePopper}
                                                ListboxProps={{ style: { maxHeight: 220, fontSize: 11 } }}
                                                renderOption={(o) => <span style={{ fontSize: 11, lineHeight: 1.3 }}>{o.portLabel}</span>}
                                                options={portOptions}
                                                filterOptions={(o) => o}
                                                value={port || ""}
                                                inputValue={port || ""}
                                                getOptionLabel={(o) => (typeof o === "string" ? o : o.name || "")}
                                                onInputChange={(e, v, reason) => {
                                                    if (reason === "reset") return;
                                                    onChangeSelectedVessel(v, "port", true);
                                                    latestPortQuery.current = v;
                                                    setPortOptions([]);
                                                    searchPorts(v);
                                                }}
                                                onChange={(e, v) => v && onChangeSelectedVessel(v.name || v, "port", true)}
                                                renderInput={(params) => (
                                                    <TextField {...params} variant="outlined" size="small" placeholder="Search Port" />
                                                )}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Date Opening</th>
                                        <td>
                                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                                <DateTimePicker
                                                    inputVariant="outlined"
                                                    size="small"
                                                    name="dateOpen"
                                                    className="date-time-picker-update-fleet"
                                                    style={{ width: "100%", background: "#ffffd6" }}
                                                    value={(vessel && vessel.dateOpen) || Date.now()}
                                                    onChange={(date) =>
                                                        onChangeSelectedVessel(date, "dateOpen", true)
                                                    }
                                                />
                                            </MuiPickersUtilsProvider>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Hire Per Day</th>
                                        <td>
                                            <input
                                                type="number"
                                                onKeyDown={handleKeyDown}
                                                value={(vessel && vessel.hirePerDay) || 0}
                                                name="hirePerDay"
                                                className="custom-input-field"
                                                onChange={(e) =>
                                                    onChangeSelectedVessel(
                                                        e,
                                                        true
                                                    )
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Hire GBB</th>
                                        <td>
                                            <input
                                                type="number"
                                                onKeyDown={handleKeyDown}
                                                value={(vessel && vessel.hireGbb) || 0}
                                                name="hireGbb"
                                                className="custom-input-field"
                                                onChange={(e) =>
                                                    onChangeSelectedVessel(
                                                        e,
                                                        true
                                                    )
                                                }
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Grid>
                    </Grid>
                </Grid>
            default:
                return 'Unknown stepIndex';
        }
    }
    const fetchDataForPdf = async () => buildVesselPdfData(vessel);

    const pdfTemplate = async () => {
        const generatedData = await fetchDataForPdf();
        setPdfData(generatedData);
    };

    useEffect(() => {
        pdfTemplate();
    }, [activeStep, vessel])

    const onDownloadPdf = async () => {
        const data = await dashboardActions.addDownloadPdf(pdfData);
        if (data) {
            return data;
        }
        return null;
    }

    return (
        <Grid container className="w-full">
            <div className={`${classes.root} [&_.vessel-details-tables_th]:whitespace-nowrap [&_.vessel-details-tables_td]:whitespace-nowrap`}>
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-1 md:gap-3 w-full mb-1">
                    <div className="flex-1 min-w-0">
                        <Stepper activeStep={activeStep} className="compact-vessel-stepper" alternativeLabel>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel><span className="hidden md:inline">{label}</span></StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        {activeStep < steps.length && (
                            <div className="md:hidden text-center text-[11px] font-medium text-slate-900 -mt-1 mb-1">
                                Step {activeStep + 1} of {steps.length}: {steps[activeStep]}
                            </div>
                        )}
                    </div>
                    <div className="shrink-0 pb-2 flex justify-end">
                        <DownloadPdf pdfData={pdfData} onDownloadPdf={onDownloadPdf} />
                    </div>
                </div>
                <div>
                    {activeStep === steps.length ? (
                        <div>
                            <Typography className={classes.instructions}>All steps completed</Typography>
                            <Button onClick={handleReset}>Reset</Button>
                        </div>
                    ) : (
                        <div>
                            <Typography component="div" className={classes.instructions} style={{ display: "flex", justifyContent: "center" }}>{getStepContent(activeStep)}</Typography>
                            <div className="flex justify-end items-center gap-2.5 mt-2.5">
                                <button
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    className="h-[28px] px-3.5 text-[11px] font-medium text-slate-900 bg-white hover:bg-slate-100 border border-slate-300 rounded-none shadow-2xs transition-colors capitalize tracking-wider cursor-pointer disabled:text-slate-400 disabled:cursor-not-allowed disabled:hover:bg-white"
                                >
                                    Back
                                </button>
                                <button
                                    onClick={handleNext}
                                    className="h-[28px] px-3.5 text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#1e2632] border border-[#313C4C] rounded-none shadow-2xs transition-colors capitalize tracking-wider cursor-pointer"
                                    data-spotlight="modal-next-btn"
                                >
                                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* <Grid item xs={12} style={{ display: "flex", justifyContent: "end" }}>

                <div style={{ width: "135px" }}>
                    <CustomButton onClick={() => onSubmitUpdateVessel()}>Update</CustomButton>
                </div>

            </Grid> */}
            {/* <Grid item xs={12} md={12} style={{ height: "100%" }}>
                <Grid container>
                    <Grid item xs={12} md={6} style={{ padding: 5 }}>
                        <div style={{ background: "lightgrey" }}>
                            <Paper>
                                <Grid container>
                                  

                                    <Grid item xs={12} className="mb-2">
                                        <div className="flex items-center gap-3 w-full mb-3">
                                            <div className="flex items-center gap-1.5 flex-1 min-w-0">
                                                <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">Vessel</span>
                                                <input
                                                    disabled={true}
                                                    value={vesselName}
                                                    type="text"
                                                    name="vesselName"
                                                    className="h-[24px] px-1.5 text-[11px] font-medium bg-slate-100 border border-slate-300 w-full outline-none"
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                            <div className="flex items-center gap-1.5 w-[85px] shrink-0">
                                                <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">Dwt</span>
                                                <input
                                                    disabled={!isFromCreateVessel}
                                                    value={vesselDwt}
                                                    name="vesselDwt"
                                                    className="h-[24px] px-1.5 text-[11px] font-medium bg-[#ffffd6] border border-slate-300 w-full outline-none disabled:bg-slate-100"
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                            <div className="flex items-center gap-1.5 w-[85px] shrink-0">
                                                <span className="text-[11px] font-medium text-slate-600 whitespace-nowrap">IMO</span>
                                                <input
                                                    disabled={!isFromCreateVessel}
                                                    value={vesselIMO}
                                                    name="vesselIMO"
                                                    className="h-[24px] px-1.5 text-[11px] font-medium bg-[#ffffd6] border border-slate-300 w-full outline-none disabled:bg-slate-100"
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} md={5} className="md:pr-1.5 mb-3 md:mb-0">
                                        <p className="mt-0 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                            Vessel Particulars
                                        </p>
                                        <table className="fleet-result-table vesselDetails !w-full">
                                            <tbody>
                                                {vesselCalculatorMainFields.map((item, key) => {
                                                    if (
                                                        item.name === "fuelType" ||
                                                        item.name === "vesselScrubber"
                                                    )
                                                        return null;
                                                    return (
                                                        <tr key={key}>
                                                            <th>{item.label}</th>
                                                            <td>
                                                                <input
                                                                    value={vessel?.[item.name] || ""}
                                                                    type={item.type}
                                                                    onKeyDown={handleKeyDown}
                                                                    name={item.name}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Grid>
                                    <Grid item xs={12} md={7} className="md:pl-1.5">
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <p className="mt-0 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Ballast Sea Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Speed</th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb1Selected"
                                                                    checked={vesselBalComb1Selected || false}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd1"
                                                                    value={vesselBalSpd1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS1"
                                                                    value={vesselBalConsmHS1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS1"
                                                                    value={vesselBalConsmLS1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO1"
                                                                    value={vesselBalConsmMGO1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb2Selected"
                                                                    checked={vesselBalComb2Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd2"
                                                                    value={vesselBalSpd2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS2"
                                                                    value={vesselBalConsmHS2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS2"
                                                                    value={vesselBalConsmLS2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO2"
                                                                    value={vesselBalConsmMGO2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb3Selected"
                                                                    checked={vesselBalComb3Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd3"
                                                                    value={vesselBalSpd3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS3"
                                                                    value={vesselBalConsmHS3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS3"
                                                                    value={vesselBalConsmLS3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO3"
                                                                    value={vesselBalConsmMGO3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselBalComb4Selected"
                                                                    checked={vesselBalComb4Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalSpd4"
                                                                    value={vesselBalSpd4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmHS4"
                                                                    value={vesselBalConsmHS4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmLS4"
                                                                    value={vesselBalConsmLS4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselBalConsmMGO4"
                                                                    value={vesselBalConsmMGO4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <p className="mt-3 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Laden Sea Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Speed</th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb1Selected"
                                                                    checked={vesselLadComb1Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd1"
                                                                    value={vesselLdnSpd1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS1"
                                                                    value={vesselLdnConsmHS1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS1"
                                                                    value={vesselLdnConsmLS1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO1"
                                                                    value={vesselLdnConsmMGO1 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb2Selected"
                                                                    checked={vesselLadComb2Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}

                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd2"
                                                                    value={vesselLdnSpd2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS2"
                                                                    value={vesselLdnConsmHS2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS2"
                                                                    value={vesselLdnConsmLS2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO2"
                                                                    value={vesselLdnConsmMGO2 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb3Selected"
                                                                    checked={vesselLadComb3Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd3"
                                                                    value={vesselLdnSpd3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS3"
                                                                    value={vesselLdnConsmHS3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS3"
                                                                    value={vesselLdnConsmLS3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO3"
                                                                    value={vesselLdnConsmMGO3 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    className="input-type-checkbox"
                                                                    name="vesselLadComb4Selected"
                                                                    checked={vesselLadComb4Selected || false}
                                                                    // onChange={onChangeHandler}
                                                                    onChange={(e) => onChangeHandler(e, false, true)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnSpd4"
                                                                    value={vesselLdnSpd4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmHS4"
                                                                    value={vesselLdnConsmHS4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmLS4"
                                                                    value={vesselLdnConsmLS4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselLdnConsmMGO4"
                                                                    value={vesselLdnConsmMGO4 || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <p className="mt-3 mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">
                                                    Port Consumptions
                                                </p>
                                                <table className="vessel-details-tables">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Main</th>
                                                            <th>ECA</th>
                                                            <th>MGO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th>Idle</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmHS"
                                                                    value={vesselPIdleConsmHS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmLS"
                                                                    value={vesselPIdleConsmLS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPIdleConsmMGO"
                                                                    value={vesselPIdleConsmMGO || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Loading</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmHS"
                                                                    value={vesselPLdgConsmHS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmLS"
                                                                    value={vesselPLdgConsmLS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPLdgConsmMGO"
                                                                    value={vesselPLdgConsmMGO || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Disch</th>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmHS"
                                                                    value={vesselPDischConsmHS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmLS"
                                                                    value={vesselPDischConsmLS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselPDischConsmMGO"
                                                                    value={vesselPDischConsmMGO || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                           <Tooltip placement="top" title={<span className="text-sm">Any Additional Lupsum Consumption in the entire voyage</span>}>
                                <th>Extra</th>
                                </Tooltip>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmHS"
                                                                    value={vesselVExtraConsmHS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmLS"
                                                                    value={vesselVExtraConsmLS || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="number"
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="0"
                                                                    name="vesselVExtraConsmMGO"
                                                                    value={vesselVExtraConsmMGO || ""}
                                                                    onChange={onChangeHandler}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={3} style={{ padding: 5, paddingLeft: 16 }}>
                        <Grid item xs={12} md={12}>
                            <span className="block mb-1.5 text-[11px] font-medium text-slate-900 capitalize tracking-wider border-l-4 border-l-[#313C4C] pl-2 leading-none py-0.5">Split hire</span>
                            <SplitHireModal
                                addNewSplitHire={addNewSplitHire}
                                selectedSplitHire={vessel}
                                onChangeSplitHire={onChangeSplitHire}
                            />
                        </Grid>
                        <Grid item xs={12} md={12} style={{ marginTop: "10px" }}>

                            <div className="show-bunker-lower-prices-from-single-vessel" style={{ width: "300px", float: "unset", marginTop: "10px" }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Bunker Qty </th>
                                            <th>Main</th>
                                            <th>ECA</th>
                                            <th>MGO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>On Delivery</th>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkDelhs} name="bnkDelhs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkDells} name="bnkDells" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkDelmgo} name="bnkDelmgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        </tr>
                                        <tr>
                                            <th>Exp on Re-Delivery</th>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliveryhs} name="bnkQtyRedeliveryhs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliveryls} name="bnkQtyRedeliveryls" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkQtyRedeliverymgo} name="bnkQtyRedeliverymgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        </tr>
                                        <tr>
                                            <th>Tolerance Acceptable</th>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancehs} name="bnkRedeliveryQtyTolerancehs" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancels} name="bnkRedeliveryQtyTolerancels" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                            <td><input type="number" onKeyDown={handleKeyDown} value={bnkRedeliveryQtyTolerancemgo} name="bnkRedeliveryQtyTolerancemgo" onChange={e => onChangeSelectedVessel(e, true)} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} style={{ marginTop: "2px", display: "flex", justifyContent: "flex-end" }}>

                            <div style={{ marginBottom: 0 }} className="sync-bunker-switch">
                                <label>Override</label>
                                <Switch
                                    checked={isOverride}
                                    onChange={e => setIsOverride(e.target.checked)}
                                    name="checkedA"
                                    color="primary"
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} style={{ marginTop: "2px" }}>

                            <div className="show-bunker-lower-prices-from-single-vessel" style={{ width: "300px", float: "unset", display: "flex" }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Bunker Prices</th>
                                            <th>Main</th>
                                            <th>ECA</th>
                                            <th>MGO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th> On Delivery</th>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceDeliveryhs}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliveryhs} disabled={!isOverride} name="bnkPriceDeliveryhs" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceDeliveryls}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliveryls} disabled={!isOverride} name="bnkPriceDeliveryls" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceDeliverymgo}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceDeliverymgo} disabled={!isOverride} name="bnkPriceDeliverymgo" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        </tr>
                                        <tr>
                                            <th> On Re-Delivery</th>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceRedeliveryhs}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliveryhs} disabled={!isOverride} name="bnkPriceRedeliveryhs" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceRedeliveryls}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliveryls} disabled={!isOverride} name="bnkPriceRedeliveryls" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceRedeliverymgo}</p> : <input onKeyDown={handleKeyDown} type="number" value={bnkPriceRedeliverymgo} disabled={!isOverride} name="bnkPriceRedeliverymgo" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        </tr>
                                        <tr>
                                            <th> For Settlement</th>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceSettlemenths}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlemenths} disabled={!isOverride} name="bnkPriceSettlemenths" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceSettlementls}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlementls} disabled={!isOverride} name="bnkPriceSettlementls" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                            <td style={{ backgroundColor: !isOverride ? "#ffffff" : "#ffffd6" }} className={!isOverride ? "bg-white" : "bg-[#ffffd6]"}>{!isOverride ? <p>{bnkPriceSettlementmgo}</p> : <input type="number" onKeyDown={handleKeyDown} value={bnkPriceSettlementmgo} disabled={!isOverride} name="bnkPriceSettlementmgo" className={!isOverride ? "bg-white cursor-not-allowed" : "bg-[#ffffd6]"} onChange={e => onChangeSelectedVessel(e, true)} />}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                        </Grid>
                        <Grid item xs={12} className="mt-2.5">
                            <table className="fleet-result-table">
                                <thead>
                                    <tr>
                                        <th colSpan="2" style={{ background: "#f1f5f9", color: "#334155" }}>
                                            Bunker Fuel specifications
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th style={{ width: "25%" }}>Main</th>
                                        <td>
                                            <Tooltip
                                                title={<span className="text-xs">{bnkFuelMain || 'empty'}</span>}
                                                placement="top"
                                                arrow
                                            >
                                                <input
                                                    name="bnkFuelMain"
                                                    type="text"
                                                    maxLength={100}
                                                    placeholder=""
                                                    value={bnkFuelMain || ''}
                                                    onChange={onChangeBunkerFuelHandler}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>ECA</th>
                                        <td>
                                            <Tooltip
                                                title={<span className="text-xs">{bnkFuelEca || 'empty'}</span>}
                                                placement="top"
                                                arrow
                                            >
                                                <input
                                                    name="bnkFuelEca"
                                                    type="text"
                                                    maxLength={100}
                                                    placeholder=""
                                                    value={bnkFuelEca || ''}
                                                    onChange={onChangeBunkerFuelHandler}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>MDO</th>
                                        <td>
                                            <Tooltip
                                                title={<span className="text-xs">{bnkFuelMgo || 'empty'}</span>}
                                                placement="top"
                                                arrow
                                            >
                                                <input
                                                    name="bnkFuelMgo"
                                                    type="text"
                                                    maxLength={100}
                                                    placeholder=""
                                                    value={bnkFuelMgo || ''}
                                                    onChange={onChangeBunkerFuelHandler}
                                                />
                                            </Tooltip>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3} style={{ padding: 5, paddingTop: "25px", paddingLeft: "10px" }}>
                        <Grid item xs={12} md={12} style={{ marginTop: "10px" }}>
                            <table className="fleet-result-table" style={{ marginBottom: "10px" }}>
                                <tr>
                                    <th>Extra Expenses</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            placeholder="0"
                                            onChange={(e) => onChangeSelectedVessel(e, true)}
                                            value={
                                                (vessel && vessel.extraExpense) || 0
                                            }
                                            name="extraExpense"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Constants</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            placeholder="0"
                                            onChange={(e) => onChangeSelectedVessel(e, true)}
                                            value={
                                                (vessel && vessel.constants) || 0
                                            }
                                            name="constants"
                                        />
                                    </td>
                                </tr>

                            </table>
                        </Grid>
                        <Grid item xs={12} md={12} style={{ marginTop: "10px" }}>

                            <table className="fleet-result-table" style={{ marginTop: "10px" }}>
                                <tr>
                                    <th>Date Opening</th>
                                    <td>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DateTimePicker
                                                inputVariant="outlined"
                                                size="small"
                                                name="dateOpen"
                                                className="date-time-picker-update-fleet"
                                                style={{ width: 135, background: "#fff" }}

                                                value={(vessel && vessel.dateOpen) || Date.now()}
                                                onChange={(date) =>
                                                    onChangeSelectedVessel(date, "dateOpen", true)
                                                }
                                            />
                                        </MuiPickersUtilsProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <th>GBB</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            value={(vessel && vessel.gbb) || 0}
                                            name="gbb"
                                            className="custom-input-field"
                                            onChange={(e) =>
                                                onChangeSelectedVessel(
                                                    e,
                                                    true
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Hire Per Day</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            value={(vessel && vessel.hirePerDay) || 0}
                                            name="hirePerDay"
                                            className="custom-input-field"
                                            onChange={(e) =>
                                                onChangeSelectedVessel(
                                                    e,
                                                    true
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>Hire GBB</th>
                                    <td>
                                        <input
                                            type="number"
                                            onKeyDown={handleKeyDown}
                                            value={(vessel && vessel.hireGbb) || 0}
                                            name="hireGbb"
                                            className="custom-input-field"
                                            onChange={(e) =>
                                                onChangeSelectedVessel(
                                                    e,
                                                    true
                                                )
                                            }
                                        />
                                    </td>
                                </tr>

                            </table>
                        </Grid>
                    </Grid>
                </Grid>


            </Grid> */}
            <CustomConfirmModal
                open={warningPopup.isOpen}
                handleClose={() => setWarningPopup({ isOpen: false, data: null })}
                message={type === "update" ? "Are you sure you want to update this fleet details?" : "Are you sure you want to create a copy of this fleet?"}
                note={type === "update" ? "Please double check all the details before updating the fleet details." : "This action will add a new copy of this fleet to your fleet list."}
                confirmBtnProps={{ "data-spotlight": "verification-confirm-btn" }}
                onSubmitConfirm={() => {
                  if (type === "update") {
                    onSubmitVessel(warningPopup.data);
                  } else {
                    setValidationVesselFromAuto();
                  }
                  setWarningPopup({ isOpen: false, data: null });
                  if (window.handleVesselTourAction) {
                    window.handleVesselTourAction('verification_complete');
                  }
                }}
                type="info"
                confirmText="Confirm"
                cancelText="Cancel"
            />
        </Grid >
    );
}

export default EditVesselOnFleetAddStep;
